import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  alternativeButtonStyle
} from '../styles/buttonStyles'

const ElectricCashbackInfoModal = ({
  open,
  onClose
}) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = e => {
      if (e.key !== 'Escape') return

      e.preventDefault()
      e.stopPropagation()

      onClose()
    }

    window.addEventListener(
      'keydown',
      handleKeyDown
    )

    return () => {
      window.removeEventListener(
        'keydown',
        handleKeyDown
      )
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <>
      <style>
        {`
          .electric-cashback-scroll {
            scrollbar-width: thin;
            scrollbar-color: rgba(217, 255, 228, 0.22) transparent;
          }

          .electric-cashback-scroll::-webkit-scrollbar {
            width: 5px;
          }

          .electric-cashback-scroll::-webkit-scrollbar-track {
            background: transparent;
          }

          .electric-cashback-scroll::-webkit-scrollbar-thumb {
            background: rgba(217, 255, 228, 0.22);
            border-radius: 10px;
          }

          .electric-cashback-scroll::-webkit-scrollbar-thumb:hover {
            background: rgba(217, 255, 228, 0.35);
          }
        `}
      </style>

      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor:
            'rgba(0,0,0,0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 5000
        }}
      >
        <div
          onClick={e =>
            e.stopPropagation()
          }
          style={{
            background: '#122629',
            padding: 20,
            border:
              '2px solid #107c6b',
            borderRadius: 12,
            boxShadow:
              '0 12px 28px rgba(0,0,0,0.65)',
            width:
              'clamp(320px, 32vw, 520px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <div
            className="electric-cashback-scroll"
            style={{
              width: '100%',
              textAlign: 'left',
              marginBottom: 24,
              maxHeight: '60vh',
              overflowY: 'auto'
            }}
          >
            <p
              style={{
                fontSize: 20,
                margin: '0 0 14px 0',
                color: '#d9ffe4',
                fontWeight: 700,
                textAlign: 'center'
              }}
            >
              {t(
                'TRIPLOG.RECEIPTS.TABLE.ELECTRIC_CASHBACK_INFO_TITLE'
              )}
            </p>

            <p
              style={{
                fontSize: 15,
                lineHeight: 1.5,
                margin: 0,
                color:
                  'rgba(217,255,228,0.85)',
                whiteSpace: 'pre-line'
              }}
            >
              {t(
                'TRIPLOG.RECEIPTS.TABLE.ELECTRIC_CASHBACK_INFO_TEXT'
              )}
            </p>

            <div
              style={{
                width: '100%',
                height: 1,
                backgroundColor:
                  'rgba(16,124,107,0.65)',
                margin: '20px 0'
              }}
            />

            <p
              style={{
                fontSize: 20,
                margin: '0 0 14px 0',
                color: '#d9ffe4',
                fontWeight: 700,
                textAlign: 'center'
              }}
            >
              {t(
                'TRIPLOG.RECEIPTS.TABLE.ELECTRIC_PROOF_INFO_TITLE'
              )}
            </p>

            <p
              style={{
                fontSize: 15,
                lineHeight: 1.5,
                margin: 0,
                color:
                  'rgba(217,255,228,0.85)',
                whiteSpace: 'pre-line'
              }}
            >
              {t(
                'TRIPLOG.RECEIPTS.TABLE.ELECTRIC_PROOF_INFO_TEXT'
              )}
            </p>
          </div>

          <button
            style={alternativeButtonStyle(
              pressedBtn,
              'closeElectricCashbackInfo',
              hoverBtn === 'closeElectricCashbackInfo'
            )}
            onMouseEnter={() =>
              setHoverBtn('closeElectricCashbackInfo')
            }
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() =>
              setPressedBtn('closeElectricCashbackInfo')
            }
            onMouseUp={() =>
              setPressedBtn(null)
            }
            onClick={onClose}
          >
            {t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default ElectricCashbackInfoModal